import { render } from "./Connect.vue?vue&type=template&id=1129cccb&ts=true"
import script from "./Connect.vue?vue&type=script&lang=ts"
export * from "./Connect.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Users\\orson\\coding\\thelounge\\thelounge\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/Windows/Connect.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1129cccb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1129cccb', __exports__)) {
    api.reload('1129cccb', __exports__)
  }
  
  module.hot.accept("./Connect.vue?vue&type=template&id=1129cccb&ts=true", () => {
    api.rerender('1129cccb', render)
  })

}


export default __exports__